export default __webpack_public_path__ + "static/media/account.4fe0a844.png";